import { DisaggregatedMetric, MetricPanelProps } from "../../services/types";
import { getMetricGroupChartId, getMetricGroupOrderIds, getSvgMap } from "../../utils/dashboardUtils";
import BannerRibbon from "../BannerRibbon";
import SimpleBarChart from "../charts/SimpleBarChart";
import SimpleDonutChart from "../charts/SimpleDonutChart";
import DisaggregateMetricCard from "../DisaggregateMetricCard";
import SoloIcon from "../SoloIcon";

const AccessibilityMetrics = ({ indicators, categorizedData, tab, geoDetails, geoTag, selectionActive }: MetricPanelProps) => {   
    const accessibilityOrders = getMetricGroupOrderIds(tab);

    const sortedAccessibilityMetrics = accessibilityOrders.map((order: number[]) => 
        categorizedData.Accessibility
            .filter(metric => order.includes(metric.id))
            .sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id))
    );
    console.log('Accessibility metrics:', sortedAccessibilityMetrics)

    const accessibility: DisaggregatedMetric[] = sortedAccessibilityMetrics[0];

    let metricsForTab = indicators; // Get metrics for the current tab

    if (!metricsForTab || metricsForTab.length === 0) {
        return <div className="flex items-center justify-center text-color-cai-dashboard">No metrics available for {tab}.</div>;
    }

    return (
        <>
            <div className="mb-2">
                <BannerRibbon text="Accessibility Indicators" color="#225591"/>
            </div> 
            <p className="text-port-text mx-4 text-[10px] mb-4">Data updates published July 15, 2025. Data testing in progress.</p>
            <div className="grid grid-cols-2 gap-4 place-items-start justify-items-center ml-4">
                {accessibility.map(metric => (
                <div key={metric.id}>
                    <div className="flex items-start justify-center">
                        {metric && 
                        <div className="flex flex-col items-start">
                            <SoloIcon
                                key={metric.id}
                                id={metric.id}
                                svg={undefined}
                                disaggData={indicators}
                                geoDetails={geoDetails}
                                geoTag={geoTag}
                                selectionActive={selectionActive}
                                margin="ml-20"
                            />
                            <SimpleDonutChart indicators={indicators} id={metric.id} fillColor="#00A18A" remainColor="#D5D5D5" valueColor="#4D4D4D"/>
                            <p className="text-port-text text-xs font-bold mt-2 max-w-32">{metric.name}</p>

                            { metric.versions[0]?.unit_descriptor && <p className="text-port-text text-xs max-w-32">{metric.versions[0]?.unit_descriptor}</p> }
                        </div>
                        }
                    </div>
                </div>
                ))}   

                <div className="col-span-2 w-full my-4 pr-4">
                    {categorizedData.Accessibility.filter(metric => 
                        [getMetricGroupChartId(tab, "commute")].includes(metric.id) // Commute Mode
                    ).map(metric => (
                        <DisaggregateMetricCard
                            key={metric.id}
                            id={metric.id}
                            metric={metric}
                            title={metric.name}
                            svg={getSvgMap(metric.id)}
                            disaggData={indicators}
                            geoDetails={geoDetails}
                            geoTag={geoTag}
                            selectionActive={selectionActive}
                            showValue={false}
                        />
                    ))}
                    <SimpleBarChart indicators={indicators} title="Commute Mode" tab="Accessibility" chartName="commute" height="h-56" barColor="#00A18A" reverseOrder={false} topFive={false}/>
                </div>            
            </div>
        </>
    );
}

export default AccessibilityMetrics;